import React from 'react';
import { ServiceDetailPage } from './ServiceDetailPage';

export const Topografia: React.FC = () => {
  const serviceData = {
    title: 'Topografía',
    description: 'Estación total para cimentaciones, estructuras, vialidades y obras de infraestructura.',
    image: '/services/Ser_Int_Topografia.jpg',
    
    sections:[
      {
        title:'Monumento ó mojonera',
        items:[
          'Punto de control geodésico',
          'Concreto, estacas ó placa de acero',
          'Georeferencia',
          'Ubicación',
        ],
      },
      {
        title:'Planimetría',
        items:[
          'Levantamiento topográfico',
          'Delimitación de terrenos',
          'Deslindes',
          'Replanteo topográfico',
          'Control de obra',
        ],
      },
      {
        title:'Altimetría',
        items:[
          'Curvas de nivel',
          'Cálculo de volumen',
        ],
      },
    ]
  };

  return <ServiceDetailPage {...serviceData} />;
};
